module.exports = __webpack_public_path__ + "img/index_domain_c.72b577e5.png";